import Image from 'next/image';

interface LogoProps {
  link: {
    href: string;
  };
  image: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
}

export function Logo({ image, link }: LogoProps) {
  return (
    <div className='text-center sm:text-left'>
      <a href={link.href || '/'} target='_self'>
        <Image
          width={image.width}
          height={image.height}
          src={image.src}
          alt={image.alt}
          quality={100}
          className='inline-block max-w-32 md:max-w-48 lg:max-w-64'
          fetchPriority='high'
          loading='eager'
        />
      </a>
    </div>
  );
}
